import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';
import { detectLanguage, saveLanguagePreference, SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './utils/language';

// Initialize i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: detectLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    debug: process.env.NODE_ENV === 'development',
    
    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'home', 'timer', 'stopwatch', 'worldclock', 'timestamp', 'discord', 'youtube', 'programming', 'terms'],
    
    resources: messages,
    
    interpolation: {
      escapeValue: false,
    },
    
    // Language detection options
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'timer-today-language',
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'],
    },
    
    // React options
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em'],
    },
  });

// Save language preference when language changes
i18n.on('languageChanged', (lng) => {
  if (SUPPORTED_LANGUAGES.includes(lng as any)) {
    saveLanguagePreference(lng as any);

    // Update document language
    document.documentElement.lang = lng;

    // Update text direction for RTL languages
    const rtlLanguages = ['ar', 'ur', 'fa'];
    document.documentElement.dir = rtlLanguages.includes(lng) ? 'rtl' : 'ltr';
  }
});

export default i18n;

// Export utilities for external use
export { detectLanguage, saveLanguagePreference } from './utils/language';
export { getSEOConfig, updateSEOTags } from './utils/seo';